import {httpBatchLink, httpSubscriptionLink, splitLink} from '@trpc/client';
import {useState} from 'react';
import {trpc} from '../utils/trpc';
import {useQueryClient} from '@tanstack/react-query';
import superjson from 'superjson';
import {isEnvironment} from '@features/utils/getEnvironment';

function getUrl() {
  const base = (() => {
    if (typeof window !== 'undefined') return '';
    if (process.env.VERCEL_URL) return `https://${process.env.VERCEL_URL}`;
    return 'http://localhost:3000';
  })();
  return `${base}/api/trpc`;
}

export function TRPCProvider({children}: {children: React.ReactNode}) {
  const queryClient = useQueryClient();
  const [trpcClient] = useState(() =>
    trpc.createClient({
      links: [
        splitLink({
          // uses the httpSubscriptionLink for subscriptions
          condition: (op) => op.type === 'subscription',
          true: httpSubscriptionLink({
            url: getUrl(),
            transformer: superjson,
          }),
          false: httpBatchLink({
            url: getUrl(),
            transformer: superjson,
            maxItems: isEnvironment('development') ? 1 : 10,
          }),
        }),
      ],
    }),
  );

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      {children}
    </trpc.Provider>
  );
}
